var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',_vm._g(_vm._b({attrs:{"align":"right","page-sizes":[10, 20, 50],"layout":"total, sizes, prev, pager, next, jumper"}},'el-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }